/**
 * Shared utility functions for sender statistics
 * Used by both Redis (KV) and database implementations
 */

import type { SenderStat } from '../types';
import { SENDER_STATS_EXPIRATION_DAYS } from '../kv/sender-stats-kv';

/**
 * Calculate the date that is N days ago from now.
 * @param days - Number of days to subtract (default: SENDER_STATS_EXPIRATION_DAYS)
 * @returns Date object representing N days ago
 */
export function getDaysAgo(days: number = SENDER_STATS_EXPIRATION_DAYS): Date {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
}

/**
 * Check if a sender stat entry is expired based on cutoff date.
 * @param stat - Sender stat entry to check
 * @param cutoffDate - Cutoff date (entries older than this are expired)
 * @returns True if entry is expired, false otherwise
 */
export function isEntryExpired(stat: SenderStat, cutoffDate: Date): boolean {
  const lastSeen = new Date(stat.last_seen);
  return lastSeen < cutoffDate;
}
